// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2L1tB","footer":"Form_footer__3tzH7"};